// src/utils/urlHelpers.ts
var generateProductItemUrl = (categoryName, itemcode) => {
  if (!categoryName || !itemcode) {
    throw new Error("Both categoryName and itemcode are required");
  }
  return `/products/${encodeURIComponent(categoryName)}/list/${encodeURIComponent(itemcode)}`;
};
var generateProductCategoryUrl = (categoryName) => {
  if (!categoryName) {
    throw new Error("categoryName is required");
  }
  return `/products/${encodeURIComponent(categoryName)}/list`;
};
var parseProductUrl = (pathname) => {
  const match = pathname.match(/^\/products\/([^/]+)\/list(?:\/([^/]+))?$/);
  if (!match) {
    return { categoryName: null, itemcode: null };
  }
  return {
    categoryName: decodeURIComponent(match[1]),
    itemcode: match[2] ? decodeURIComponent(match[2]) : null
  };
};

export {
  generateProductItemUrl,
  generateProductCategoryUrl,
  parseProductUrl
};
